import { render } from "./CustomerIntegrationsEdit.vue?vue&type=template&id=4b83ab2c"
import script from "./CustomerIntegrationsEdit.vue?vue&type=script&lang=js"
export * from "./CustomerIntegrationsEdit.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__